import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import { styled, Stack } from '@hub-la/design-system';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import PhoneNumber from 'react-phone-number-input/mobile';
import { PhoneField } from './phone-field.js';

let _ = t => t,
  _t;
const PhoneNumberStyledInternal = styled(PhoneNumber)(_t || (_t = _`
  & {
    position: relative;
  }

  & .PhoneInputCountry {
    position: absolute;
    z-index: 2;
    padding: 16px 0 16px 12px;
  }

  & .PhoneInputCountry .MuiSvgIcon-root {
    margin-left: 3px;
  }

  & label[data-shrink='false'] {
    padding-left: 59px;
    padding-top: 2px;
  }

  & input {
    padding-left: 75px;
  }
`));
/** Provides a component that shows the country flag inside the input field. */
function PhoneNumberStyled(props) {
  const defaultProps = {
    defaultCountry: 'BR',
    placeholder: '( )',
    inputComponent: PhoneField,
    countrySelectProps: {
      arrowComponent: ArrowDropDown
    }
  };
  return jsx(Stack, {
    children: jsx(PhoneNumberStyledInternal, Object.assign({}, defaultProps, props))
  });
}

export { PhoneNumberStyled };
